"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Building2 } from "lucide-react";
import type { CompanyMetadata } from "@/lib/integrations/quickbooks/quickbooks-multi-company-utils";

interface SimpleCompanyBadgeProps {
  company: CompanyMetadata;
  variant?: "default" | "secondary" | "outline" | "destructive";
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function SimpleCompanyBadge({
  company,
  variant = "secondary",
  size = "sm",
  className = "",
}: SimpleCompanyBadgeProps) {
  const sizeClasses = {
    sm: "text-xs px-2 py-1",
    md: "text-sm px-3 py-1.5",
    lg: "text-base px-4 py-2",
  };

  return (
    <Badge variant={variant} className={`${sizeClasses[size]} gap-1 ${className}`}>
      <Building2 className="h-3 w-3" />
      <span>{company.companyName}</span>
      {company.environment && <span className="text-xs opacity-75">({company.environment})</span>}
    </Badge>
  );
}
